export default "__VITE_ASSET__DiKiI94y__"